import React from 'react';
import { TableCell, TableRow } from '@/components/shared/table';
import OpportunityDefinition from './OpportunityDefinition';
import { OpportunityScore } from '@/types/opportunity';

interface OpportunityRowProps {
  opportunity: OpportunityScore;
  index: number;
  rank: number;
  isFirstItem?: boolean;
}

const OpportunityRow = ({ opportunity, index, rank, isFirstItem }: OpportunityRowProps) => {
  return (
    <>
      {/* Desktop row: Rank | Opportunity | Value Score | Feasibility Score | Final Score */}
      <TableRow className="hidden lg:table-row hover:bg-gray-50/50 transition-colors">
        <TableCell className="align-middle font-medium text-center text-gray-700">{rank}</TableCell>
        <TableCell className="align-middle">
          <div className="flex items-center gap-3">
            <OpportunityDefinition name={opportunity.Name} defaultOpen={isFirstItem} />
          </div>
        </TableCell>
        <TableCell className="align-middle text-center font-medium">
          {Math.round(opportunity.valueScore)}%
        </TableCell>
        <TableCell className="align-middle text-center font-medium">
          {Math.round(opportunity.feasibilityScore)}%
        </TableCell>
        <TableCell className="align-middle text-center font-medium">
          {Math.round(opportunity.finalScore)}%
        </TableCell>
      </TableRow>
      
      {/* Mobile row: Rank | Opportunity | Final Score | Value Score | Feasibility Score */}
      <TableRow className="lg:hidden hover:bg-gray-50/50 transition-colors">
        <TableCell className="align-middle font-medium text-center text-gray-700">{rank}</TableCell>
        <TableCell className="align-middle">
          <div className="flex items-center gap-3">
            <OpportunityDefinition name={opportunity.Name} defaultOpen={isFirstItem} />
          </div>
        </TableCell>
        <TableCell className="align-middle text-center font-medium">
          {Math.round(opportunity.finalScore)}%
        </TableCell>
        <TableCell className="align-middle text-center font-medium">
          {Math.round(opportunity.valueScore)}%
        </TableCell>
        <TableCell className="align-middle text-center font-medium">
          {Math.round(opportunity.feasibilityScore)}%
        </TableCell>
      </TableRow>
    </>
  );
};

export default OpportunityRow;